'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/minus/Minus.tsx
import { jsx } from "react/jsx-runtime";
var MinusIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "12",
      height: "2",
      viewBox: "0 0 12 2",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx("rect", { width: "12", height: "2", rx: "1", fill: "currentColor" })
    })
  );
};

export {
  MinusIcon
};
//# sourceMappingURL=chunk-BVWDHMT6.mjs.map